import React from 'react';

const AlreadyEnrolled = () => {

    return ( <>
        <div className="mb-8">
          <div className="font-bold text-3xl">Your recent enrollment changes are being processed.</div>
        </div> 
        <p className='my-4'>
          They may take up to 24 hours to complete. Please contact Beth Mellenthin at 314-592-2206 or Sara Benignus at 314-492-2566 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a> for additional information. 
        </p>
        
        </> );
}
 
export default AlreadyEnrolled;